import React from "react";
import { useLocation, useParams } from "react-router-dom";
import DemoLessonFlow from "./DemoLessonFlow";

function useStudentId() {
  const params = useParams();
  const fromQuery = new URLSearchParams(useLocation().search).get("studentId");
  const raw = fromQuery || params.studentId || params.id || localStorage.getItem("student_id") || "SM01K4R9";
  return String(raw).toUpperCase();
}

export default function GuidedDemoPage() {
  const location = useLocation();
  const studentId = useStudentId();

  const search = new URLSearchParams(location.search);
  const source = search.get("source") || "dashboard";
  const returnTo = search.get("returnTo") || "";

  return (
    <div className="lesson-wrap lesson-wrap--portal">
      <div style={{ height: "48px" }} />
      <div className="lp-main">
        <DemoLessonFlow
          studentId={studentId}
          source={source}
          returnTo={returnTo}
        />
      </div>
    </div>
  );
}
